var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.sale)?_c('search-component',{staticClass:"m-t-15",attrs:{"show_selected":false,"model_name":"article","search_from_api":"","props_to_filter":['name', 'bar_code', 'provider_code']},on:{"setSelected":_vm.setSelected}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }